import { erpAxios } from '..';

const insertTroskoviDomacinstva = async (data) => {
  await erpAxios.post(`/troskovi-domacinstva/add`, data);
};

export default insertTroskoviDomacinstva;
